import { ConnectSectionWrapperComponent } from "./wrappers/connect-section"
import { SectionWrapperComponent } from "./wrappers/section"
import { InputFieldTypeComponent } from "./types/input"
import { ConfigOption } from "@ngx-formly/core"
import { RadioFieldTypeComponent } from "./types/radio-buttons"
import { SelectFieldTypeComponent } from "./types/select"
import { ElementRef } from "@angular/core"
import { DateFieldTypeComponent } from "./types/datepicker"
import { DurationFieldTypeComponent } from "./types/duration"
import { ArrayFieldTypeComponent } from "./types/array"
import { CheckboxFieldTypeComponent } from "./types/checkbox"
import { FormGroup, Validators } from "@angular/forms"
import { HelpFieldTypeComponent } from "./types/help"
import { TextAreaFieldTypeComponent } from "./types/textarea"

export default {
    wrappers: [
        { name: 'connectSection', component: ConnectSectionWrapperComponent },
        { name: 'section', component: SectionWrapperComponent }
    ],
    types: [
        // { name: 'object', component: ObjectTypeComponent },
        { name: 'radiobuttons', component: RadioFieldTypeComponent },
        { name: 'select', component: SelectFieldTypeComponent },
        { name: 'input', component: InputFieldTypeComponent },
        { name: 'datepicker', component: DateFieldTypeComponent },
        { name: 'duration', component: DurationFieldTypeComponent },
        { name: 'array', component: ArrayFieldTypeComponent },
        { name: 'checkbox', component: CheckboxFieldTypeComponent },
        { name: 'help', component: HelpFieldTypeComponent },
        { name: 'textarea', component: TextAreaFieldTypeComponent }
    ],
    validators: [
        { name: 'requiredTrue', validation: Validators.requiredTrue },
    ],
    validationMessages: [
        { name: 'required', message: "Required" },
        { name: 'minLength', message: (error) => `String is too short (${error.actualLength} chars) minimum ${error.requiredLength}` },
        { name: 'maxLength', message: (error) => `String is too long (${error.actualLength} chars) maximum ${error.requiredLength}` },
    ]
} as ConfigOption

export const formatFormErrors = (el: ElementRef, form: FormGroup) => {
    const formattedErrors: FormattedError[] = [];

    const parentElements = el.nativeElement.querySelectorAll('.has-error');

    if (parentElements) {
        parentElements.forEach((node: any) => {
            try {
                const id: string = node.id;
                // console.log(id);

                const title: string = node.querySelector('.control-label').textContent;
                // console.log(title);

                const msg: string = node.querySelector('.help-block').textContent;
                // console.log(msg);


                if (!id || !title || !msg) {
                    console.error("error data incomplete", { id, title, msg });
                }

                formattedErrors.push({
                    name: id,
                    title: title,
                    msg: msg,
                })
            }
            catch (error) {
                console.error("node error", node)
            }
        })
    }

    //any form errors on the form itself are used for broadcasting and included here
    if (form.errors) {
        for (const [ key, value ] of Object.entries(form.errors)) {
            // console.log(key, value, broadcastValidationMsgs[ key ])

            formattedErrors.push({
                name: key,
                title: value[ 'title' ],
                msg: value[ 'msg' ]
            })
        }
    }

    return formattedErrors;
}

type FormattedError = {
    name: string;
    title: string;
    msg: string;
}
